var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationpin20 = function SvgLocationpin20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.166c-.69 0-1.25-.561-1.25-1.25 0-.69.56-1.25 1.25-1.25.689 0 1.25.56 1.25 1.25 0 .689-.561 1.25-1.25 1.25Zm0-4.167a2.92 2.92 0 0 0-2.917 2.917A2.92 2.92 0 0 0 10 10.832a2.92 2.92 0 0 0 2.916-2.916A2.92 2.92 0 0 0 10 4.999Zm0 11.372c-1.396-1.32-5-5.026-5-8.103 0-2.721 2.242-4.935 5-4.935 2.757 0 5 2.214 5 4.935 0 3.077-3.604 6.783-5 8.103Zm0-14.705c-3.676 0-6.667 2.96-6.667 6.602 0 4.562 5.874 9.649 6.124 9.863a.832.832 0 0 0 1.085 0c.25-.214 6.124-5.3 6.124-9.863 0-3.641-2.99-6.602-6.666-6.602Z",
    fill: "#008545"
  })));
};
export default SvgLocationpin20;